import dataSelect from "@store/dataForSelect/reducers";

import { level_select } from "@Modules/Exams/configs/constants";

export default dataSelect(level_select);
